import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Before every other import that could reach axios: this patches axios.create,
// so only the instances built after it carry the "not your permission" reporter.
// See src/permissions/roleDenial.js.
import './permissions/roleDenial.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppProvider from './providers/AppProvider';
import { BreakpointsProvider } from './providers/BreakpointsProvider';
import SettingsPanelProvider from './providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from './Routes.js';
import './helpers/initFA.js';
import AuthProvider from './providers/AuthProvider.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <AppProvider>
        <SettingsPanelProvider>
          <BreakpointsProvider>
            <RouterProvider router={router} />
          </BreakpointsProvider>
        </SettingsPanelProvider>
      </AppProvider>
    </AuthProvider>
  </QueryClientProvider>
  // </React.StrictMode>
);
